import { ModalWithTransition } from '@studiometa/ui';
import { withBreakpointObserver } from '@studiometa/js-toolkit';

/**
 * Modal component
 * @param  {Class} SliderCore
 * @returns {void}
 */
export default class Modal extends withBreakpointObserver(ModalWithTransition) {
  static config = {
    component: {
      Modal: ModalWithTransition,
    },
    options: {
      open: Boolean,
      activeBreakpoints: {
        type: String,
        default: 'xxs xs s',
      },
    },
  };

  /**
   * Mount element and open modal if no value in session storage item
   * @returns {void}
   */
  mounted() {
    if (sessionStorage.getItem('popin_displayed')) {
      return;
    }

    this.$on('open', this.setItem);

    if (this.$options.open) {
      setTimeout(() => {
        this.open();
      }, 500);
    }
  }

  /**
   * Add item to session storage
   * @returns {void}
   */
  setItem() {
    sessionStorage.setItem('popin_displayed', true);
  }
}
